export default __webpack_public_path__ + "17de4e65c66f76bb1f14f17c244b1213.svg";